import React, { FC, useContext } from 'react';
import find from 'lodash/find';
import get from 'lodash/get';
import isNil from 'lodash/isNil';
import set from 'lodash/set';

import FormContext from 'src/presentation/contexts/FormContext';
import { InputField as ADInputField } from 'src/presentation/components/agent_desktop_components';

export enum InputType {
  text = 'text',
  number = 'number',
  password = 'password',
}

export type InputFieldProps = {
  'data-aid'?: string;
  action?: JSX.Element;
  attr: string;
  autoFocus?: boolean;
  className?: string;
  description?: string | JSX.Element;
  disabled?: boolean;
  errorAttr?: string;
  label?: string;
  maxLength?: number;
  onBlur?: Function;
  onChange?: Function;
  placeholder?: string;
  readOnly?: boolean;
  type?: InputType;
  value?: string;
};

const InputField: FC<InputFieldProps> = React.forwardRef((props, ref) => {
  const { errors, workingState, updateState, resetError, onBlur: onBlurFromContext } = useContext(FormContext);
  const { action, attr, className, errorAttr = attr, onBlur, onChange, type = InputType.text, value, ...rest } = props;
  const error = find(errors, error => get(error, 'attr') === errorAttr);
  const val = !isNil(value) ? value : get(workingState, attr);

  const changeHandler = (val = '') => {
    if (onChange) {
      return onChange(val);
    } else {
      resetError({ attr, errors });
      updateState(set({}, attr, isNil(val) ? '' : val));
    }
  };

  return (
    <ADInputField
      action={action}
      className={error ? `${className} invalid` : className}
      error={get(error, 'detail')}
      inputType={type}
      onBlur={onBlur || onBlurFromContext}
      onChange={changeHandler}
      ref={ref}
      value={val}
      {...rest}
    />
  );
});

export default InputField;
